// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectAreaGroupPageLoading,
  selectAreaGroupShowInitWaitingMessage,
  selectAreaGroupsInStore,
} from '../_selectors/area_group.selectors';

export class AreaGroupDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectAreaGroupPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectAreaGroupShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectAreaGroupsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
